module.exports = __webpack_public_path__ + "static/media/barre.d35f2989.jpg";